import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../reducers';
import ImportManager from '../../containers/ImportManager';
import { importDesktopFiles } from '../../containers/ImportManager/actions';
import { StyledMenuButton } from '../DropdownMenu/styles';
import Utils from '../../utils';

interface ImportDesktopFileProps {
	dispatch: Dispatch<StoreState>;
	onClick?: () => void;
}

const ImportDesktopFile = ({ onClick, dispatch }: ImportDesktopFileProps) => {
	const handleImport = (files: File[]) => {
		if (onClick) {
			onClick();
		}
		dispatch(importDesktopFiles(files));
	};

	return (
		<ImportManager
			id="import-desktop-file"
			triggerComponent={
				<StyledMenuButton as="div">
					{Utils.getSvgIcon('iconset_uprez_import_file')}
					<Translate value="messages.import_file" />
				</StyledMenuButton>
			}
			isMultiple={true}
			customImportHandler={handleImport}
		/>
	);
};

export default ImportDesktopFile;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/index.tsx